import { NavLink } from "react-router-dom";
import { routePaths } from "../constants/routes";

export default function CourseCard({
  title,
  description,
  badge,
  duration,
  price,
  outcomes = [],
  ctaLabel = "View Course",
  ctaTo = routePaths.enroll,
  secondaryLabel,
  onSecondaryClick,
  className = "",
}) {
  return (
    <article className={`course-summary-card surface-card ${className}`.trim()}>
      {badge && <span className="ui-badge">{badge}</span>}
      <h3>{title}</h3>
      {description && <p>{description}</p>}
      <div className="course-summary-meta">
        {duration && <span>{duration}</span>}
        {price && <span>{price}</span>}
      </div>
      {outcomes.length > 0 && (
        <ul>
          {outcomes.map((outcome) => (
            <li key={outcome}>{outcome}</li>
          ))}
        </ul>
      )}
      <div className="course-summary-actions">
        <NavLink className="btn-ui" to={ctaTo}>
          {ctaLabel}
        </NavLink>
        {secondaryLabel && (
          <button className="btn-ui-secondary" type="button" onClick={onSecondaryClick}>
            {secondaryLabel}
          </button>
        )}
      </div>
    </article>
  );
}
